import { useReorderState } from '../../../../screens/ReorderingScreen';

/**
 * Returns the active reordering restaurant slug, if available,
 */
export const useActiveReorderRestaurantSlug = () => {
  const { reordering: isReordering, restaurantSlug: reorderRestaurantSlug } =
    useReorderState();

  return isReordering ? reorderRestaurantSlug : undefined;
};
